module.exports = __webpack_public_path__ + "static/media/wind_turbine_transp.7d8d97c7.gif";